const getNumber = value => {
    if (!value) return 0;
    const stripped = value.replace(/\D+/g, "");
    return Number(stripped);
};

const calculateTotal = () => {
    let total_deposit = 0;
    const offer_value = getNumber(
        document.getElementById("offer_value")?.value
    );
    const initial_deposit = getNumber(
        document.getElementById("initial_deposit")?.value
    );
    const balance_deposit = getNumber(
        document.getElementById("balance_deposit")?.value
    );
    if (offer_value > 0 && initial_deposit > 0) {
        total_deposit = (
            ((initial_deposit + balance_deposit) / offer_value) *
            100
        ).toFixed(2);
    }
    const total_deposit_block = document.querySelector(".totalDepositValue");
    if (total_deposit_block) {
        total_deposit_block.innerHTML = total_deposit + "%";
    }
};

const handleChange = input => {
    if (input.value) {
        input.value = formatNumber(input.value);
    }
    input.addEventListener("input", event => handleInput(event));
    input.addEventListener("blur", event => handleBlur(event));
};

const handleInput = event => {
    event.preventDefault();
    const { value } = event.target;
    if (value === "") return;

    const formattedValue = formatNumber(value);
    updateValueAndCursor(event, value, formattedValue);
    calculateTotal();
};

const handleBlur = event => {
    event.preventDefault();
    const { value } = event.target;
    if (value === "") return;
    const stripped = value.replace(/\D+/g, "");
    event.target.value =
        Number(stripped) <= 0 ? "" : event.target.value.replace(/^0+/, "");
};

const updateValueAndCursor = (event, inputValue, formattedValue) => {
    let caretPosition = event.target.selectionStart;
    event.target.value = formattedValue;
    caretPosition = formattedValue.length - inputValue.length + caretPosition;
    if (caretPosition < 0) {
        event.target.setSelectionRange(0, 0);
    } else {
        event.target.setSelectionRange(caretPosition, caretPosition);
    }
};

const formatNumber = value => {
    return value.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const handleSubmission = input => {
    input.form.addEventListener("submit", event => {
        if (event) event.preventDefault();
        input.value = getNumber(input.value);
    });
};

const initFields = fields => {
    if (fields) {
        fields.forEach(field => {
            let input = field.querySelector("input");
            handleChange(input);
            handleSubmission(input);
        });
        calculateTotal();
    }
};

window.addEventListener("load", () => {
    const fields = document.querySelectorAll(".currency-field");
    initFields(fields);

    window.Livewire.hook("message.processed", (e, components) => {
        const fields = components.el.querySelectorAll(".currency-field");
        initFields(fields);
    });
});
